module.exports = __webpack_public_path__ + "static/img/qianhouyi1@2x.8dab2687.png";